export default `
  ... on Node {
    id
    created
    modified
  }
`;
